class SingleRecruit {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.initFloatMenu();
    }
  }

  initFloatMenu() {
    const floatMenu = document.querySelector('.js-recruit-float-menu');
    const footer = document.querySelector('.js-footer');
    if (!floatMenu) return;

    const scrollThreshold = 500;
    let ticking = false;

    const update = () => {
      const footerReached = footer
        ? footer.getBoundingClientRect().top <= window.innerHeight
        : false;
      const isVisible = window.scrollY >= scrollThreshold && !footerReached;

      floatMenu.classList.toggle('is-visible', isVisible);
      floatMenu.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }
}
